module.exports = require("./fr-TD");